"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotify = exports.useNotifications = exports.Notifications = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const initialState = [];
const NotificationsStateContext = react_1.createContext(initialState);
const NotificationsDispatchContext = react_1.createContext(undefined);
const notificationReducer = (state, action) => {
    let newState = [].concat(state);
    switch (action.type) {
        case 'add':
            let notification = Object.assign({ uuid: uuid_1.v4() }, action.payload);
            newState.push(notification);
            return newState;
        case 'remove':
            return newState.filter((notification) => {
                return notification.uuid !== action.payload;
            });
    }
};
exports.Notifications = ({ children }) => {
    const [state, dispatch] = react_1.useReducer(notificationReducer, []);
    return react_1.default.createElement(NotificationsStateContext.Provider, { value: state },
        react_1.default.createElement(NotificationsDispatchContext.Provider, { value: dispatch }, children));
};
exports.useNotifications = () => {
    const state = react_1.useContext(NotificationsStateContext);
    const dispatch = react_1.useContext(NotificationsDispatchContext);
    if (!dispatch) {
        throw new Error("useNotifications can only be called within <Notifications>");
    }
    const removeNotification = (uuid) => {
        dispatch({ type: 'remove', payload: uuid });
    };
    return { notifications: state, removeNotification };
};
exports.useNotify = () => {
    const dispatch = react_1.useContext(NotificationsDispatchContext);
    if (!dispatch) {
        throw new Error("useNotifications can only be called within <Notifications>");
    }
    const notify = (notification) => {
        dispatch({ type: 'add', payload: notification });
    };
    return { notify };
};
//# sourceMappingURL=hook-notifications.js.map